import axios from "axios";
import { toast } from "react-hot-toast";

export const CREATE_CANTEEN_REQUEST = "CREATE_CANTEEN_REQUEST";
export const CREATE_CANTEEN_SUCCESS = "CREATE_CANTEEN_SUCCESS";
export const CREATE_CANTEEN_FAILURE = "CREATE_CANTEEN_FAILURE";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const createCanteen = (formData) => async (dispatch) => {
  dispatch({ type: CREATE_CANTEEN_REQUEST });

  try {
    // console.log("Creating canteen with data:", formData); // Debug log
    console.log(
      "%cdb test - Creating canteen with data:",
      "color: yellow; font-size: 12px; font-weight: bold;",
      formData,
    );
    const res = await axios.post(
      `${BASE_URL}/api/maa_canteen/kiosk/add`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json",
        },
      }
    );

    dispatch({
      type: CREATE_CANTEEN_SUCCESS,
      payload: res.data.data,
    });

    toast.success("Canteen created successfully");

    return res.data; 
  } catch (error) {
    console.error("Error creating canteen:", error); // Debug log
    dispatch({
      type: CREATE_CANTEEN_FAILURE,
      payload:
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message,
    });

    toast.error("Failed to create canteen");
    throw error; // optional but recommended
  }
};
